export const notions = [
  {
    title: "Contact Forms Components",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2Fb39fdc5c-c694-4d79-904c-91d11a75e644%2Fthumbnail-contact-forms-amrhnshh.vercel.app.jpeg/size/w=1530?exp=1728047934&sig=shmivs5hlzgUxV49gRzVoJyTrQtKAoY6TJouz3iVgzo",
    description:
      "Components of contact form + zod validation + pdf attachment + google sheets integration",
    hashtag: [
      "next-js",
      "tailwind",
      "typescript",
      "react-hook-form",
      "framer-motion",
      "shadcn-ui",
    ],
    internetUrl: "https://contact-forms-amrhnshh.vercel.app/",
  },
  {
    title: "My Website v3 (ongoing)",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2Fbfdacf0a-9ebd-4861-8770-0a79d82990a6%2Fscreencapture-staging-amrhnshh-vercel-app-2024-04-15-15_21_42.png/size/w=1430?exp=1728048360&sig=RWNmNvtzp-k8rZSE83XsGUu11VNbgfCTP5SryQMvHyU",
    description:
      "Redesign my pixel-perfect websites with NextJS + Tailwind CSS + Framer Motion = Animation (on-going)",
    hashtag: [
      "next-js",
      "tailwind",
      "typescript",
      "web-design",
      "figma",
      "framer-motion",
      "shadcn-ui",
    ],
    internetUrl: "https://staging-amrhnshh.vercel.app/",
  },
  {
    title: "E-commerce App (MERN)",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F08e38a90-21f4-4c25-bf11-a2dcf38cc903%2Fecommerce-app-mern.jpeg/size/w=1430?exp=1728048598&sig=vAO6eytEa1rGRFglY6e76IOjEX8cPasKMJyv7g9GZFI",
    description:
      "Electronic commerce app with ReactJS, Context API (useReducer), Styled Components integrate with backend MongoDB database",
    hashtag: [
      "full-stack",
      "react-js",
      "express-js",
      "crud",
      "mongodb",
      "javascript",
    ],
    internetUrl: "https://ecommerce-app-alpha-henna.vercel.app/",
  },
  {
    title: "Weather App Guide",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2Faf3d69f4-47a0-435e-8865-3db136d6714a%2Fweather-app-guide.jpeg/size/w=1430?exp=1728048696&sig=wE4Kgf7tX6W4avuKSIIWY7a5UszuszxO4K8bTLNCiwM",
    description:
      "OpenMeteo API for the longitude and latitude, and OpenCage API to geocode the location which was passed on and extract the coordinates - 2 APIs in one app",
    hashtag: [
      "express-js",
      "back-end",
      "ejs",
      "javascript",
      "no-db",
      "rest-api",
    ],
    internetUrl: "https://weather-app-expressjs-aora.onrender.com/",
  },
  {
    title: "Food Order App (Cloudinary)",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2Fb2c8b24f-82fb-490e-b51a-aaa9241fc4e4%2Ffood-order-app-customer01.png/size/w=600?exp=1728048711&sig=vtYPRb5PSrdBozTsp5AT8nPFzMD_Rz8uIFJxl0Ci-js",
    description:
      "Food Ordering App - ReactJS (useReducer) + Context API + Material UI + Cloudinary Image Upload + JSON Server CRUD",
    hashtag: [
      "cloudinary",
      "image-upload",
      "json-server",
      "material-ui",
      "reactjs",
      "midjourney",
    ],
    internetUrl: "https://food-order-app-vercel.vercel.app/",
  },
  {
    title: "Find My News App",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F43cd6770-0bc9-4059-a588-79325ca3cda0%2Ffind-my-news-login.jpeg/size/w=600?exp=1728048765&sig=v0cMlB0XFB8ReAp6Sxow-1en1HtA_PCs64JbzR9tbds",
    description:
      "Find news about Twitter - uses News API + LocalStorage Auth + dotenv + Bookmark + Load More + Custom Button + Search bar + MUI",
    hashtag: [
      "authorization",
      "dotenv",
      "loadmore",
      "localstorage",
      "material-ui",
      "newsapi",
      "reactjs",
      "midjourney",
    ],
    internetUrl: "https://add-to-fav-simple-app.vercel.app/",
  },
  {
    title: "Mock API Simple App",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2Fb4c7f07b-6335-4f43-8c57-cfde722d36d2%2Fmock-api-home.jpeg/size/w=600?exp=1728048796&sig=lDOAZCtQ1aRPJVohoYpU49UpKFhvDPnKSeGpMDrQtpE",
    description:
      "Mock API App - Favorite Feature + Search Bar + LocalStorage Login Authentication + Load More functionality + MUI customizations",
    hashtag: [
      "authorization",
      "loadmore",
      "localstorage",
      "material-ui",
      "mock-api",
      "reactjs",
    ],
    internetUrl: "https://add-to-fav-simple-app.vercel.app/",
  },
  {
    title: "Contact Manager App",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2Fc6437e6a-5172-4322-ab49-a9c0e3fd046c%2Fcontact-management-app-jade.vercel.app.jpeg/size/w=600?exp=1728048815&sig=MlFG1U-sUoi33SEEwkuw-kcMN0dNcaWSJVsohdV8zFk",
    description:
      "Building a CRUD application that can store a list of contacts with React + Semantic UI + JSON Server",
    hashtag: [
      "react-router-dom",
      "json-server",
      "reactjs",
      "semantic-ui",
      "context-api",
      "CRUD",
    ],
    internetUrl: "https://contact-management-app-jade.vercel.app/",
  },
  {
    title: "Portfolio Design Tailwind",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F64f7f0df-8c5d-47d8-b65a-7e201723b1ed%2Ftailwind-design-light.png/size/w=600?exp=1728048859&sig=GMBSFGIgH4s1ic5hWtsQTS2yJlT3dBG8BUlMuvFUqW4",
    description:
      "Tailwind Portfolio Web Design - NextJS + Dark Mode + Elegant Design + Skills, Projects, and Experiences Showcase",
    hashtag: ["nextjs", "tailwind", "css", "website design", "darkmode"],
    internetUrl: "https://tailwind-react-portfolio-theta.vercel.app/",
  },
  {
    title: "My Website Design Tailwind v1",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F93a10470-d237-4ae2-9ec5-e3a527515ebb%2Famrhnshh-minimalist.png/size/w=600?exp=1728048880&sig=sHpFBatCXZoyJTbbO90wA8QuAgdCyv-80nmW_5SQa8U",
    description:
      "Tailwind Portfolio Web Design Part 2 - NextJS + router + Tailwind + Vercel deployment",
    hashtag: ["nextjs", "tailwind", "css", "website design"],
    internetUrl: "https://amrhnshh-minimalist.vercel.app/",
  },
  {
    title: "The Ninja List (NextJS)",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F9a5d2168-4e49-4d58-b9cc-68e75233d930%2Ftn-ninjaslist.png/size/w=600?exp=1728048896&sig=yTnGZLCuOOcnycPtB6vPRQw5OppIxWRbVDFNT4LgNHc",
    description:
      "The Ninja List - NextJS + JSON Placeholder API + Simple REST Integration",
    hashtag: ["nextjs", "css"],
    internetUrl: "https://ninjas-list-zeta.vercel.app/",
  },
  {
    title: "Titanic Database (SQL)",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2Ff8d770ff-53de-4eed-ac37-f1b5d33b9c6f%2Fthumbnail-sql-titanic.png/size/w=600?exp=1728048940&sig=oWUT8jJVP7jgWKrTFjht6_VnhPf_iFt-MWiCXS3hASI",
    description:
      "The Titanic SQL dataset provides information about the passengers onboard the Titanic - Kaggle + Notion",
    hashtag: ["database", "sql", "notion", "sqlite"],
    internetUrl:
      "https://amirahnasihah.notion.site/Project-1-Exploring-Titanic-Database-320e9feb0a984f96a2a1aaacc288eade",
  },
  {
    title: "HTML CV web with Bootstrap",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2Fc26d2a8f-0f50-4580-abe3-6831259ceaf0%2Fcv_amirahnasihah.github.io.jpeg/size/w=1700?exp=1728048965&sig=UkxkkeCT5UBQPDa8EBUZpKrR8acvz9MQu_LwTpauuQg",
    description:
      "Create a static webpage using HTML and incorporating Bootstrap and CSS to enhance and to create a responsive and visually appealing webpage",
    hashtag: ["css", "html", "bootstrap"],
    internetUrl: "https://amirahnasihah.github.io/",
  },
  {
    title: "Basic Photo Album MUI",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F828bb5ce-756e-46ba-b698-e4012e536e05%2FScreenshot_20230113_112131.png/size/w=600?exp=1728048980&sig=j1xZJCPHGJlDmveUqz4jj3qOHdN34Wgspc2cSGeYomA",
    description:
      "Practice building a user interface for a photo album using Material UI",
    hashtag: ["material-ui", "reactjs"],
    internetUrl: "https://amirahnasihah.github.io/album-mui-demo/",
  },
  {
    title: "Blackjack Game",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2Fa6a2f862-0e08-43c8-a7db-d33ebe59cacb%2FScreenshot_20221203_111627.png/size/w=600?exp=1728048996&sig=F2sRyk7dxit1rsLka4xGGUoh6d3gBoE5EcERQozniUw",
    description:
      "Blackjack hands are scored by their point total. The hand with the highest total wins as long as it doesn't exceed 21; a hand with a higher total than 21 is said to bust",
    hashtag: ["css", "html", "javascript"],
    internetUrl: "https://blackjack-amrhsnhh.netlify.app/",
  },
  {
    title: "Passenger Count",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2Fa47d5258-14d9-4e01-b92c-66b3141663d0%2Fthumbnail-passenger-counter.jpg/size/w=600?exp=1728049018&sig=JT82YyZQpsB_4dzS5Bgr9oGhvofj7nWtxuNHkavbUvY",
    description: "Save for the feature to count passenger",
    hashtag: ["css", "html", "javascript"],
    internetUrl: "https://passenger-count-amrhnshh.netlify.app/",
  },
  {
    title: "Calculator Challenge",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F67db7592-2bd5-45ee-a5e2-d23aac23e7d9%2Fthumbnail-calclulator.jpg/size/w=600?exp=1728049037&sig=3N8xeZLdEgGXMDBmKZtjHMq6YUgUbxBJqjDA3Jh-VUI",
    description: "JavaScript DOM, on click event listener, inner text",
    hashtag: ["css", "html", "javascript"],
    internetUrl: "https://calculator-challenge-amrhnshh.netlify.app/",
  },
  {
    title: "JavaScript CMD Mini Games",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2Fb2388fbe-46b4-4bdc-a4b2-e5093fb4f3c0%2Fthumbnail-mini-js-cmdline.jpg/size/w=600?exp=1728049050&sig=-bIBuQFrvmE4wypVt3VcIZbobmdexM0TMQ59eSOG3oE",
    description: "Command Prompt tic tac toe + guess number game",
    hashtag: ["command-prompt", "javascript"],
    internetUrl: "https://github.com/amirahnasihah/javascript-miniprojects",
  },
  {
    title: "Testing Web App",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F97e8dd0d-f8e0-471a-9db3-461b7a1ca6fa%2Flaravelreact.png/size/w=600?exp=1728049064&sig=FbWrT_XtroaAJCeSBCnDrnUIiuq-WeyDu5dUGhgrz4s",
    description: "CRUD application framework with ReactJS + Laravel",
    hashtag: ["laravel", "php", "reactjs"],
    internetUrl: "https://github.com/amirahnasihah/laravel-web-application",
  },
  {
    title: "Portfolio Webpage",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F3f735ab4-163a-4088-9e10-802ad85f5e53%2FScreenshot_(80)_-_Copy.png/size/w=600?exp=1728049077&sig=-KGWR6FcwJxjlwp27i8i4wTzPJEDcb09WgeNrzZIp9E",
    description: "Responsive web design with HTML, CSS",
    hashtag: ["css", "html", "javascript"],
    internetUrl: "https://codepen.io/amirahnasihah/pen/PoEbwoV",
  },
  {
    title: "Landing Page",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F184f7ff9-daae-4ec0-bcff-342ce70d9266%2Fthumbnail-trombones-landing-page.png/size/w=600?exp=1728049087&sig=zbOBaZxiqK3CZVCQI0o4zMyOUj6MPqt8L1jFvwO5epg",
    description: "Product landing page with embedded video",
    hashtag: ["css", "html", "javascript"],
    internetUrl: "https://codepen.io/amirahnasihah/pen/xxpRxWR",
  },
  {
    title: "Documentation Page",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F68881e68-8901-44ad-b47f-7b00142c50e6%2Fthumbnail-js-document-page.png/size/w=600?exp=1728049104&sig=vJ-TIcS6KKkzrn4ly6SA0Hc47Wg-9MLoi47G5NBxoIA",
    description: "Class and ID in CSS",
    hashtag: ["css", "html", "javascript"],
    internetUrl: "https://codepen.io/amirahnasihah/pen/MWrbWRa",
  },
  {
    title: "Tribute Page - P. Ramlee",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F222c7d55-e707-437d-bea2-687b9b87b1d9%2Fthumbnail-pramlee-tribute-page169.jpeg/size/w=600?exp=1728049120&sig=iAkK2FrjOfz1t5h0BgxOEJi2X2yUtr9ks_gZrZBS2s0",
    description: "Control the colour, font, size, spacing",
    hashtag: ["css", "html", "javascript"],
    internetUrl: "https://codepen.io/amirahnasihah/pen/XWVdgoV",
  },
  {
    title: "Survey Form",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F90ba8d04-905e-4847-a617-c4254ee13355%2Fthumbnail-ateez-survey1.jpeg/size/w=600?exp=1728049138&sig=Oq9LYBQgF4kLk7Zy0ZkHaCQZkiMxbq4OuHewiVxwguI",
    description: "HTML, CSS, Visual Design",
    hashtag: ["css", "html", "javascript"],
    internetUrl: "https://codepen.io/amirahnasihah/pen/XWVdgoV",
  },
  {
    title: "Responsive Web Design",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F16f03b10-d6cf-4906-8807-8761c0838037%2Fthumbnail-notion-fcc-responsive-design.png/size/w=600?exp=1728049156&sig=CHk3BT86UihJ4YWdm7hC4fGFJ3YhWSBbR9IoOaYoBfs",
    description: "Applying HTML and CSS",
    hashtag: ["css", "html", "javascript"],
    internetUrl: "https://github.com/amirahnasihah/responsive-web-design",
  },
  {
    title: "Accounting Software Mockup",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F8dd4a97a-22b6-4ac2-895b-d9c5585fb09d%2Fagentloop1.png/size/w=600?exp=1728049170&sig=_LmWvl7vH-g6hluxeQROhlBkDwxB6e2taqPEbkvTUpU",
    description:
      "Create mockups, wireframes, and UI prototypes using Pidoco online tools which are built for accounting software for the purpose of group assignment.",
    hashtag: ["lofi-prototype", "mock-up", "pidoco", "uitm"],
    internetUrl:
      "https://github.com/amirahnasihah/uitm-projects-assignment/tree/6458c17c978530193297472fdd9b4a48885cb407/MAF661%20UI%20Design%20Accounting%20Software",
  },
  {
    title: "Payroll DB System (MS Access)",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2Fbc1c8ebf-f838-4d08-b547-9e9ccbd6c50e%2Flpsb_payroll_system.png/size/w=600?exp=1728049185&sig=kKTTfJWNCp41KkClwJ2Vweqmul7DY_P6BXos3S1SBGo",
    description:
      "Problem-Based Learning MS Access - Accounting System Analysis and Design (AIS655)",
    hashtag: ["lofi-prototype", "ms-access", "uitm"],
    internetUrl:
      "https://github.com/amirahnasihah/uitm-projects-assignment/tree/main/payroll-system-database-ms-access",
  },
  {
    title: "Barfé Business Proposal",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F2f32c2ec-3905-4b5d-9090-4c967ff3d0c3%2Fbarfecafe.jpg/size/w=600?exp=1728049204&sig=4QnrwPBlTT5SJM35ZWgUozxuz0luJfm_M-URs6mRSlM",
    description:
      "Services specifically focused on women’s hair treatment with a cafe inside",
    hashtag: ["microsoft-office", "ms-words", "report", "uitm"],
    internetUrl:
      "https://github.com/amirahnasihah/uitm-projects-assignment/tree/main/ENT300",
  },
  {
    title: "Payroll System with Microsoft Visio",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2Fdb895081-aa8a-46ca-80c0-d5de8f4ee66c%2FMicrosoft_Office_Visio_(2019).svg.png/size/?exp=1728049222&sig=q5eAsAM8-0EtSxbpmxDGoAMXuEpRTC6f8ykaCIroJ6Y",
    description:
      "Create a process flowchart using Microsoft Visio. It is a Problem Based Learning by Accounting Information System (AIS615) course.",
    hashtag: ["microsoft-office", "ms-visio", "uitm"],
    internetUrl:
      "https://github.com/amirahnasihah/uitm-projects-assignment/blob/6458c17c978530193297472fdd9b4a48885cb407/PBL%204%20Payroll%20System%20Cozy%20Clothing%20Company.vsdx",
  },
  {
    title: "Sales Order Processing and Cash Receipt System",
    cover:
      "https://img.notionusercontent.com/s3/prod-files-secure%2Fdb8a1f5e-6728-4e4a-b2d0-43bb6f822e3f%2F248431ae-3845-40d6-9ec2-f58823ffd261%2FMicrosoft_Office_Visio_(2019).svg.png/size/?exp=1728049233&sig=cFwOF0TMtaLhE8U6JOadjhn8qi35KWiwdCxLCYIj_x8",
    description:
      "Sales Order Processing and Cash Receipt System of Rapid Electronics Company. It is a Problem-Based Learning by Accounting Information System (AIS615) course.",
    hashtag: ["microsoft-office", "ms-visio", "uitm"],
    internetUrl:
      "https://github.com/amirahnasihah/uitm-projects-assignment/blob/6458c17c978530193297472fdd9b4a48885cb407/PBL%201%20Sales%20Order%20Processing%20and%20Cash%20Receipt%20System%20Rapid%20Electronics%20Company.vsdx",
  },
];

export default notions;
